import React from 'react';
interface FooterProps {
  onOpenPrivacy: () => void;
  onOpenTerms: () => void;
}
export function Footer({
  onOpenPrivacy,
  onOpenTerms
}: FooterProps) {
  return <footer className="w-full pb-8 pt-2 flex items-center justify-center gap-8" data-id="element-26">
      <button type="button" onClick={onOpenPrivacy} className="text-sm md:text-base font-bold text-blue-700 underline hover:text-blue-900 bg-transparent border-0 cursor-pointer p-0" data-id="element-27">
        Privacy Policy
      </button>
      <button type="button" onClick={onOpenTerms} className="text-sm md:text-base font-bold text-blue-700 underline hover:text-blue-900 bg-transparent border-0 cursor-pointer p-0" data-id="element-28">
        Terms of Use
      </button>
    </footer>;
}